import {
  CONTINUE_TRANSACTION_STATE,
  TRANSACTION_STATE,
} from "../../constants/status";

export const INITIAL_STATE = {
  isLoading: false,
  continueTransaction: CONTINUE_TRANSACTION_STATE.NONE,
  transactionState: TRANSACTION_STATE.NONE,
  merchantName: "LuckyBet",
  merchantReturnUrl: "https://www.google.com",
  bankName: "PNC",
  bankLogoUrl: null,
  transactionType: null,
  transactionAmount: null,
  transactionLimit: null,
  accountSubType: "Chase",
  accountNumberMask: "1234",
  redirectUrl: null,
  error: {
    message: null,
    subMessage: null,
    subscription: null,
  },
  error_code: null,
  rfpMonitoring: false,
  rfpError: null,
};
